export const EXCHANGE = "EXCHANGE";
export const APP_LANG = "LANGUAGE"
export const APP_CONTENT = "APP_CONTENT"
export const TOAST = "TOAST"
